<template>
  <v-snackbar
  content-class="snackbar"
    centered
    multi-line
    outlined
    rounded="pill"
    :color="color"
    v-model="snackbar"
    :timeout="timeout"
    >{{ message }}
    <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="alertClosed"
        >
          Close
        </v-btn>
      </template></v-snackbar
  >
</template>

<script>
import router from '@/router/index.js'

export default {
  props: ['returnUrl'],
  name: 'statusalert',

  data: () => ({
    snackbar: false,
    color: 'success',
    message: '',
    statusCode: 200,
    timeout: 100000
  }),

  methods: {

    displayResult(result) {
      this.statusCode = result.statusCode
      if (result.isValid) {
        this.color = 'success'
      } else {
        this.color = 'error'
      }
      this.snackbar = true
      this.message = result.errors[0]
      this.timeout = 10000
    },

    alertClosed() {
      this.snackbar = false
      if (this.statusCode === 200 && this.returnUrl) {
        router.push(this.returnUrl)
      } else {
        this.$emit('closed')
      }
    },
  },

  watch: {
    snackbar() {
      if(!this.snackbar) {
        this.$emit('closed')
      }
    }
  }
}
</script>
<style >
.v-snack__content {
    flex-grow: 1;
    font-size: 3.0rem;
    font-weight: 400;
    letter-spacing: 0.0178571429em;
    line-height: 1.25rem;
    margin-right: auto;
    padding: 14px 16px;
    text-align: initial;
}
</style>
